import cx from 'classnames';
import React from 'react';
import { Button } from '../button';
import styles from './accordion.module.scss';
export const renderAccordionActionButtons = (actionButtons, actionButtonsAlwaysVisible) => actionButtons &&
    actionButtons
        .slice(0, 2) // Limiting to only 2 action buttons
        .map((actionButton, index) => {
        const { isDisabled, tooltip, onClick: btnOnClick, icon, dataTestId, trackId, } = actionButton;
        return (React.createElement(Button
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: index, className: cx(styles.accordionAdditionalBtn, {
                [styles.actionButtonsAlwaysVisible]: actionButtonsAlwaysVisible,
            }), backgroundType: "light", type: "secondary", size: "s", isDisabled: isDisabled, "data-tooltip-content": tooltip, "data-testid": dataTestId, "track-id": trackId, onClick: (event) => {
                event.stopPropagation();
                btnOnClick(event);
            }, ariaLabel: tooltip, icon: icon }));
    });
//# sourceMappingURL=accordion-util.js.map